<ng-container *ngIf="permConfig.isAddAllowed">
  <div class="container-fluid">
    <app-page-title
      [title]="!viewOnlyPage ? (manifestId ? 'Update Manifest' : 'Add Manifest') : 'Manifest (View Only)'"></app-page-title>
    <div class="row">
      <form [formGroup]="manifestForm">
        <div class="row">
          <div [ngClass]="{'col-md-12': viewOnlyPage, 'col-md-8': !viewOnlyPage}">
            <div class="card">
              <div class="card-header bg-transparent border-bottom text-uppercase">Info</div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-2">
                    <div class="mb-2">
                      <label for="dateTime" class="form-label">Manifest date<span class="mandatory">*</span></label>
                      <input #dateTime type="date" class="form-control form-control-sm" formControlName="txtDateTime"
                        [min]="minDateTime" [max]="currentDateTime.dateString" (input)="validateDate()"
                        [ngClass]="{'is-invalid': (manifestFormSubmitted || manifestForm.get('txtDateTime')?.touched) && manifestForm.get('txtDateTime').errors}"
                          (keydown.enter)="useEnterKey && manifestForm.get('txtDateTime').valid ? btnradio4.focus() : manifestForm.get('txtDateTime').markAsTouched()"/>
                      <div
                        *ngIf="(manifestFormSubmitted || manifestForm.get('txtDateTime')?.touched) && manifestForm.get('txtDateTime').errors"
                        class="invalid-feedback">
                        <span *ngIf="manifestForm.get('txtDateTime').errors.required">Manifest Date time is
                          required</span>
                        <span *ngIf="manifestForm.get('txtDateTime').errors.minDate">Manifest Date time must be
                          valid</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="mb-2 d-flex flex-column">
                      <div class="label">
                        <label for="status" class="form-label">Manifest For</label>
                      </div>
                      <div role="group" aria-label="radio button group" class="btn-group">
                        <input #btnradio4 type="radio" id="btnradio4" autocomplete="off" class="btn-check"
                          formControlName="manifestFor" value="Service Center"
                          (change)="updateServiceCenterVendorValidator()" 
                            (keydown.enter)="useEnterKey && btnradio5.focus()">
                        <label for="btnradio4" class="btn btn-outline-secondary btn-sm">Service Center</label>
                        <input #btnradio5 type="radio" id="btnradio5" autocomplete="off" class="btn-check"
                          formControlName="manifestFor" value="Third Party"
                          (change)="updateServiceCenterVendorValidator()" 
                            (keydown.enter)="useEnterKey && checkManifetForAndFocus()">
                        <label for="btnradio5" class="btn btn-outline-secondary btn-sm">Third Party</label>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-3" *ngIf="!showVendors">
                    <div class="mb-2">
                      <label for="servicecenter" class="form-label">To Service Center<span class="mandatory">*</span></label>
                      <ng-select #serviceCenterRef id="servicecenter" [items]="serviceCenterList" bindLabel="name" placeholder="Select"
                        [bindValue]="'id'" [appendTo]="'body'" [openOnEnter]="false" groupBy="hub" formControlName="ddlServiceCenter"
                        (change)="onChangeField($event, '')"
                        [ngClass]="{'is-invalid': (manifestFormSubmitted || manifestForm.get('ddlServiceCenter')?.touched) && manifestForm.get('ddlServiceCenter').errors}"
                          (keydown.enter)="useEnterKey && manifestForm.get('ddlServiceCenter').valid ? remarks.focus() : manifestForm.get('ddlServiceCenter').markAsTouched()"
                        >
                        <ng-template ng-label-tmp let-item="item">
                          <span *ngIf="item.hub">{{item.hub}} : {{item.name}}</span>
                          <span *ngIf="!item.hub">{{item.name}}</span>
                        </ng-template>
                      </ng-select>
                      <div
                        *ngIf="(manifestFormSubmitted || manifestForm.get('ddlServiceCenter')?.touched) && manifestForm.get('ddlServiceCenter').errors"
                        class="invalid-feedback">
                        <span *ngIf="manifestForm.get('ddlServiceCenter').errors.required">Service
                          Center is
                          required</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3" *ngIf="showVendors">
                    <div class="mb-2">
                      <label for="vendor" class="form-label">To Vendor <span class="mandatory">*</span></label>
                      <ng-select #vendorRef id="vendor" [items]="vendorList" bindLabel="name" placeholder="Select"
                        [bindValue]="'id'" [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlVendor"
                        (change)="onChangeField($event, 'Third Party')"
                        [ngClass]="{'is-invalid': (manifestFormSubmitted || manifestForm.get('ddlVendor')?.touched) && manifestForm.get('ddlVendor').errors}"
                        (keydown.enter)="useEnterKey && manifestForm.get('ddlVendor').valid ? remarks.focus() : manifestForm.get('ddlVendor').markAsTouched()">
                      </ng-select>
                      <div *ngIf="(manifestFormSubmitted || manifestForm.get('ddlVendor')?.touched) && manifestForm.get('ddlVendor').errors" class="invalid-feedback">
                        <span *ngIf="manifestForm.get('ddlVendor').errors.required">Vendor is required</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="mb-2">
                      <label for="remarks" class="form-label">Remarks</label>
                      <input #remarks type="text" class="form-control form-control-sm" id="remarks" formControlName="txtRemarks" maxlength="150" 
                          (keydown.enter)="useEnterKey && company.focus()">
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="mb-2">
                      <label for="company" class="form-label">Company</label>
                      <ng-select #company class="form-control form-control-sm" formControlName="ddlCompany" id="company"
                        [items]="companyList" bindLabel="name" [bindValue]="'id'" placeholder="select"
                        [appendTo]="'body'" [openOnEnter]="false"
                        class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                        (keydown.enter)="useEnterKey && manifestForm.get('ddlCompany').valid ? awbNoInput.nativeElement.focus() : manifestForm.get('ddlCompany').markAsTouched()">
                      </ng-select>
                    </div>
                  </div>
                </div>

                <div *ngIf="!viewOnlyPage" class="row">
                    <div class="col-md-3">
                        <label for="awbchk" class="form-label">Generate AWB</label>
                        <div class="form-check form-switch form-switch-md mb-2">
                            <input #awbchk id="awbchk" type="checkbox" (change)="changeFocusOnSwitch()" formControlName="chkCreateAwb" class="form-check-input">
                        </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="!viewOnlyPage" class="col-md-4">
            <div class="card">
              <div class="card-header bg-transparent border-bottom text-uppercase">Filter AWB destination wise</div>
              <div class="card-body mb-2">
                <div class="row mb-3" formGroupName='filterDeastinationForm'>
                  <div class="col-md-4">
                    <div class="mb-2">
                      <label for="country" class="form-label">Country</label>
                      <ng-select #countryRef id="country" formControlName="ddlDestinationCountry" placeholder="Select"
                        [items]="countryList" bindLabel="name" [bindValue]="'isocode'" [appendTo]="'body'" [openOnEnter]="false"
                        (change)="onCountryChange(manifestForm,'filterDeastinationForm','destination')"
                          (keydown.enter)="useEnterKey && state.focus()"
                        >
                      </ng-select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="mb-2">
                      <label for="state" class="form-label">State</label>
                      <ng-select #state id="state" formControlName="ddlDestinationState" placeholder="Select"
                        [items]="destinationStateList" bindLabel="name" [bindValue]="'isocode'" [appendTo]="'body'" [openOnEnter]="false"
                        (change)="onStateChange(manifestForm,'filterDeastinationForm','destination')" appEnterDirective
                          (keydown.enter)="useEnterKey && city.focus()">
                      </ng-select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="mb-2">
                      <label for="city" class="form-label">City</label>
                      <ng-select #city id="city" formControlName="ddlDestinationCity" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false"
                        [items]="destinationCityList" bindLabel="name" [bindValue]="'isocode'" appEnterDirective
                          (keydown.enter)="useEnterKey && filterBtn.focus()">
                      </ng-select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="mb-2 mt-1">
                      <button #filterBtn type="button" class="btn btn-primary btn-sm" (click)="filterAWBDestination()">
                        <i class="mdi mdi-filter-variant"></i>Filter
                      </button>
                      <button type="button" class="btn btn-secondary btn-sm ms-2" (click)="clearFilter()">
                        <i class="mdi mdi-filter-remove"></i>Clear Filter
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <form *ngIf="!viewOnlyPage && showAWBDetailsForm" [formGroup]="awbDetailsForm">
        <div class="row mt-2">
          <div class="card">
            <div class="card-header bg-transparent border-bottom text-uppercase">AWB DETAILS</div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-3">
                  <div class="mb-2">
                    <label for="customer" class="form-label">Customer</label>
                    <ng-select #customer id="customer" placeholder="Select" [items]="customerList" [appendTo]="'body'" [openOnEnter]="false"
                      formControlName="ddlCustomer" bindLabel="name" [bindValue]="'id'" (change)="bindCustomerShipperInfo()"
                      (keydown.enter)="useEnterKey && companyAwb.focus()">
                    </ng-select>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="mb-2">
                    <label for="company" class="form-label">Company <span class="mandatory">*</span></label>
                    <ng-select #companyAwb id="company" placeholder="Select" [items]="companyList" [clearable]="false"
                      [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlCompanies" bindLabel="name" [bindValue]="'id'"
                      class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                      [ngClass]="{'is-invalid':(awbDetailsFormSubmitted || awbDetailsForm.get('ddlCompanies').touched) && awbDetailsForm.get('ddlCompanies').errors }"
                      (keydown.enter)="useEnterKey && awbDetailsForm.get('ddlCompanies').valid ? bookDateTime.focus() : awbDetailsForm.get('ddlCompanies').markAsTouched()">
                    </ng-select>
                    <div
                      *ngIf="(awbDetailsFormSubmitted || awbDetailsForm.get('ddlCompanies').touched) && awbDetailsForm.get('ddlCompanies').errors "
                      class="invalid-feedback">
                      <span *ngIf="awbDetailsForm.get('ddlCompanies').errors.required">Company is
                        required</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-2">
                    <label for="bookDateTime" class="form-label">Book Date</label>
                    <input #bookDateTime type="datetime-local" class="form-control form-control-sm" 
                      formControlName="txtBookingDate" [min]="minDateTime" max="3000-12-31T23:59"
                      (input)="validateDate()"
                      [ngClass]="{'is-invalid': (awbDetailsFormSubmitted || awbDetailsForm.get('txtBookingDate')?.touched) && awbDetailsForm.get('txtBookingDate').errors}"
                      (keydown.enter)="useEnterKey && awbDetailsForm.get('txtBookingDate').valid ? paymentType.focus() : awbDetailsForm.get('txtBookingDate').markAsTouched()"/>
                    <div
                      *ngIf="(awbDetailsFormSubmitted || awbDetailsForm.get('txtBookingDate')?.touched) && awbDetailsForm.get('txtBookingDate').errors"
                      class="invalid-feedback">
                      <span *ngIf="awbDetailsForm.get('txtBookingDate').errors.minDate">Book Date must be valid</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-2">
                    <label for="paymentType" class="form-label">Payment Type<span class="mandatory">*</span></label>
                    <ng-select #paymentType id="paymentType" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false" [items]="paymentTypeList"
                      formControlName="ddlPaymentType" 
                      [ngClass]="{'is-invalid': (awbDetailsFormSubmitted || awbDetailsForm.get('ddlPaymentType')?.touched) && awbDetailsForm.get('ddlPaymentType').errors}"
                      (keydown.enter)="useEnterKey && awbDetailsForm.get('ddlPaymentType').valid ? product.focus() : awbDetailsForm.get('ddlPaymentType').markAsTouched()">
                    </ng-select>
                    <div
                      *ngIf="(awbDetailsFormSubmitted || awbDetailsForm.get('ddlPaymentType')?.touched) && awbDetailsForm.get('ddlPaymentType').errors"
                      class="invalid-feedback">
                      <span *ngIf="awbDetailsForm.get('ddlPaymentType').errors.required">Payment
                        Type is required</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-2">
                  <div class="mb-2">
                    <label for="product" class="form-label">Product <span class="mandatory">*</span></label>
                    <ng-select #product [items]="productList" bindLabel="name" [bindValue]="'id'" [appendTo]="'body'" [openOnEnter]="false"
                      formControlName="ddlProduct" placeholder="Select"
                      class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                      [ngClass]="{'is-invalid':(awbDetailsFormSubmitted || awbDetailsForm.get('ddlProduct').touched) && awbDetailsForm.get('ddlProduct').errors }"
                      (keydown.enter)="useEnterKey && awbDetailsForm.get('ddlProduct').valid ? companyAwb.focus() : awbDetailsForm.get('ddlProduct').markAsTouched()">
                      </ng-select>
                      <span *ngIf="selectedProduct?.shipmenttype" style="font-size:11px;" class="badge bg-primary mt-1">Shipment type :
                        {{selectedProduct?.shipmenttype}}</span>
                    <div
                      *ngIf="(awbDetailsFormSubmitted || awbDetailsForm.get('ddlProduct').touched) && awbDetailsForm.get('ddlProduct').errors"
                      class="invalid-feedback">
                      <span *ngIf="awbDetailsForm.get('ddlProduct').errors.required">Product is
                        Required</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-2">
                    <label for="vendor" class="form-label">Vendor <span class="mandatory">*</span></label>
                    <ng-select #vendor [items]="vendorList" bindLabel="name" [bindValue]="'id'" [appendTo]="'body'" [openOnEnter]="false"
                      formControlName="ddlVendor" placeholder="Select" (change)="getAllVendorServices()" 
                      class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                      [ngClass]="{'is-invalid': (awbDetailsFormSubmitted || awbDetailsForm.get('ddlVendor').touched) && awbDetailsForm.get('ddlVendor').errors }"
                      (keydown.enter)="useEnterKey && awbDetailsForm.get('ddlVendor').valid ? service.focus() : awbDetailsForm.get('ddlVendor').markAsTouched()">
                    </ng-select>
                    <div
                      *ngIf=" (awbDetailsFormSubmitted || awbDetailsForm.get('ddlVendor').touched) && awbDetailsForm.get('ddlVendor').errors "
                      class="invalid-feedback">
                      <span *ngIf="awbDetailsForm.get('ddlVendor').errors.required">Vendor is
                        Required</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-2">
                    <label for="service" class="form-label">Service<span class="mandatory">*</span></label>
                    <ng-select #service [items]="vendorServiceList" bindLabel="servicename" [bindValue]="'id'"
                      placeholder="Select" formControlName="ddlVendorService" [appendTo]="'body'" [openOnEnter]="false"
                      class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                      [ngClass]="{ 'is-invalid':(awbDetailsFormSubmitted || awbDetailsForm.get('ddlVendorService').touched) && awbDetailsForm.get('ddlVendorService').errors}"
                      (keydown.enter)="useEnterKey && awbDetailsForm.get('ddlVendorService').valid ? chargesTypes.focus() : awbDetailsForm.get('ddlVendorService').markAsTouched()">
                    </ng-select>
                    <div *ngIf="(awbDetailsFormSubmitted || awbDetailsForm.get('ddlVendorService').touched) && awbDetailsForm.get('ddlVendorService').errors "
                      class="invalid-feedback">
                      <span *ngIf="awbDetailsForm.get('ddlVendorService').errors.required">Service is
                        Required</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-2">
                    <label class="form-label">Charge Types</label>
                    <ng-select #chargesTypes [items]="selectChargeTypes" [multiple]="true" [appendTo]="'body'" [openOnEnter]="false"
                      class="ng-select ng-select-multiple ng-select-searchable ng-select-clearable ng-select-bottom"
                      formControlName="ddlChargeType" placeholder="Select"
                      (keydown.enter)="useEnterKey && shipmentValue.focus()">
                    </ng-select>
                  </div>
                </div>
                <div class="col-md-1">
                  <div class="mb-2">
                    <label for="shipmentValue" class="form-label">Shipment Value</label>
                    <input #shipmentValue type="number" class="form-control form-control-sm" id="shipmentValue"
                      (keydown)="onKeyDown($event)" formControlName="txtShipmentValue"
                      [ngClass]="{'is-invalid':(awbDetailsFormSubmitted ||awbDetailsForm.get('txtShipmentValue').touched) && awbDetailsForm.get('txtShipmentValue').errors}"
                      (keyup.enter)="useEnterKey && (isShipperCustomerBinded? focusConsignee(): appShipperAddress.focusFirstField())"/>
                    <div *ngIf="(awbDetailsFormSubmitted || awbDetailsForm.get('txtShipmentValue').touched) && awbDetailsForm.get('txtShipmentValue').errors"
                      class="invalid-feedback">
                      <span *ngIf=" awbDetailsForm.get('txtShipmentValue').errors.pattern">Max length is 12 characters and at most three decimal places</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row col-md-12">
            <div class="col-md-6">
              <div class="card">
                <div class="card-header bg-transparent border-bottom text-uppercase"> SHIPPER </div>
                <div class="card-body">
                  <app-address #appShipperAddress formGroupName="shipperlocationdetails" [formSubmitted]="isFormSubmitted"
                  [listType]="'origin'" [address]="shipperLocationInfo" 
                  [countryList] = "countryList"
                  [conditionalCountryList]="conditionalCountryList" 
                  (addressBookListEmit)="getAddressbookList($event)" (byLocationChange)="isShipperCustomerBinded = false"
                  (getAddress)="getOriginLocation($event)" 
                  (focusEmit)="focusNextField('appShipperAddress')" [focusCheckHide]="focusCheckHide" (emitAddressCheck)="updateAddressCheck($event)">
                </app-address>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="card">
                <div class="card-header bg-transparent border-bottom text-uppercase"> CONSIGNEE </div>
                <div class="card-body">
                  <app-address #appConsigneeAddress formGroupName="consigneelocationdetails" [formSubmitted]="isFormSubmitted"
                    [listType]="'destination'" [address]="consigneeLocationInfo" [productFilteredCountryList]="productFilteredCountryList"
                    [conditionalCountryList]="conditionalCountryList" (addressBookListEmit)="getAddressbookList($event)"
                    (getAddress)="getDestinationLocation($event)"
                    [focusConsigneeName]="focusConsigneeName" [countryList] = "countryList"
                    (focusEmit)="focusNextField('appConsigneeAddress')" [focusCheckHide]="focusCheckHide">
                  </app-address>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="card">
            <div class="card-header bg-transparent border-bottom text-uppercase"> PIECES DETAILS
            </div>
            <div class="card-body">
              <div class="row d-flex">
                <div class="col-md-2 mb-2">
                  <div class="mb-2">
                    <label for="measurementUnit" class="form-label">Measurement Unit</label>
                    <ng-select #measurementUnit id="measurementUnit" bindLabel="name" [items]="unitList" placeholder="Select"
                      [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlMeasurementUnit" (change)="volumetricDetails('',true)"
                      [ngClass]="{ 'is-invalid': (isFormSubmitted || awbDetailsForm.get('ddlMeasurementUnit')?.touched) && awbDetailsForm.get('ddlMeasurementUnit').errors }"
                      (keydown.enter)="useEnterKey && focusFirstActualWeight()">
                    </ng-select>
                    <div
                      *ngIf="(isFormSubmitted || awbDetailsForm.get('ddlMeasurementUnit')?.touched) && awbDetailsForm.get('ddlMeasurementUnit').errors"
                      class="invalid-feedback">
                      <span *ngIf="awbDetailsForm.get('ddlMeasurementUnit').errors.required">Unit is
                        required</span>
                    </div>
                  </div>
                </div>
  
                <div class="col-md-1 mb-2">
                  <div class="mb-2">
                    <label for="division" class="form-label">Division</label>
                    <input #division type="text" id="division" class="form-control form-control-sm" formControlName="txtDivision"
                      (keydown.enter)="useEnterKey"/>
                  </div>
                </div>
              </div>
              <form [formGroup]="piecesForm">
                <div class="row mt-2 responsive-section">
                  <!-- Total Pieces Section -->
                  <div class="col-lg-1 col-md-2 col-sm-3 col-6 mb-2">
                    <label for="totalpieces" class="form-label">Total Pieces <span class="mandatory">*</span></label>
                    <input type="number" formControlName="totalpieces" class="form-control form-control-sm"
                      id="totalpieces" min="1" max="30" (keydown)="totalPiecesValidate($event)"
                      [ngClass]="{ 'is-invalid': (isFormSubmitted || piecesForm.get('totalpieces')?.touched) && piecesForm.get('totalpieces').errors }" />
                    <div *ngIf="(isFormSubmitted || piecesForm.get('totalpieces')?.touched) && piecesForm.get('totalpieces').errors" class="invalid-feedback">
                      <span *ngIf="piecesForm.get('totalpieces').errors.required">Total Pieces are required</span>
                    </div>
                  </div>

                  <!-- Weight Section -->
                  <div class="col-lg-5 col-md-6 col-sm-9 col-12 mb-2">
                    <label for="weight" class="form-label">Weights</label>
                    <div class="input-group">
                      <span class="input-group-text group-label-sm">Actual <span class="mandatory">*</span></span>
                      <input type="number" class="form-control form-control-sm" id="actualweight"
                        formControlName="totalactualweight"
                        (keydown)="piecesValidate($event)"
                        [ngClass]="{ 'is-invalid': (isFormSubmitted || piecesForm.get('totalactualweight').touched) && piecesForm.get('totalactualweight').errors }" />

                      <span class="input-group-text group-label-sm">Volumetric</span>
                      <input type="number" class="form-control form-control-sm" id="volumetricweight"
                        formControlName="totalvolumetricweight" (keydown)="piecesValidate($event)"
                        [ngClass]="{ 'is-invalid': (isFormSubmitted || piecesForm.get('totalvolumetricweight').touched) && piecesForm.get('totalvolumetricweight').errors }" />

                      <span class="input-group-text group-label-sm">Chargeable</span>
                      <input type="number" class="form-control form-control-sm" id="chargeweight"
                        formControlName="totalchargeableweight" (keydown)="piecesValidate($event)"
                        [ngClass]="{ 'is-invalid': (isFormSubmitted || piecesForm.get('totalchargeableweight').touched) && piecesForm.get('totalchargeableweight').errors }" />

                      <span class="input-group-text group-label-sm">Unit</span>
                      <ng-select #unit [items]="unitOptions" bindLabel="name" [clearable]="false" [bindValue]="'name'"
                        [appendTo]="'body'" [openOnEnter]="false" formControlName="actualweightunit" placeholder="Select"
                        class="ng-select" (keydown.enter)="useEnterKey && focusFirstActualWeight()">
                      </ng-select>
                    </div>
                  </div>

                  <!-- Add New Row Button -->
                  <div
                    class="col-lg-6 col-md-6 col-sm-6 col-6 text-center mt-sm-0 d-flex align-items-end justify-content-end">
                    <button type="button" (click)="addNewContainerCustom();"
                      class="btn btn-primary btn-sm d-block mb-2">
                      <i class="mdi mdi-plus"></i> Add New Row
                    </button>
                  </div>
                </div>
                    <div class="d-flex flex-wrap mt-2 mb-1 custom-item-summary">
                      <span class="badge bg-primary mx-1 my-1" style="font-size: 12px;">Item Amount:  <strong class="mx-2">{{ totals.totalAmount }}</strong></span>
                        <span class="badge bg-primary mx-1 my-1" style="font-size: 12px;">Item Weight:  <strong class="mx-2">{{ totals.totalWeight }}</strong></span>
                        <span class="badge bg-primary mx-1 my-1" style="font-size: 12px;">Item Quantity:  <strong class="mx-2">{{ totals.totalQuantity }}</strong></span>
                    </div>
                <div class="table-responsive mt-1">
                  <table class="table mb-0">
                      <thead class="table-light">
                          <tr>
                              <th class="expandcols"></th>
                              <th>Piece No</th>
                              <th>Pieces Count</th>
                              <th>
                                Actual Weight/Piece<span class="mandatory">*</span>
                              </th>
                              <th>Dimensions</th>
                              <th>Volumetric Weight</th>
                              <th>Chargeable Volumetric Weight</th>
                              <th>Action</th>
                          </tr>
                      </thead>
                      <tbody>
                        <ng-container formArrayName="containers" *ngFor="let pc of containers.controls; let i = index">
                          <ng-container formGroupName="{{i}}">
                            <tr class="tabl-row-wid">
                              <td class="expandcols">
                                <div class="icon-input-container mt-1">
                                  <i [class]="expandedRows[i] ? 'bx bx-chevron-down font-size-20 align-middle' : 'bx bx-chevron-right font-size-20 align-middle'"
                                    style="cursor: pointer" title="Expand" (click)="toggleRowExpansion(i)"></i>
                                </div>
                              </td>
                              <td class="mt-1 pieceno"><input type="hidden" formControlName="piecescounter" [value]="i+1" />{{i+1}}</td>
                              <td class="piececount">
                                <input #piecescount type="number" formControlName="piecescount"
                                  class="form-control form-control-sm" (keydown)="totalPiecesValidate($event)" min="1" 
                                  (keydown.enter)="useEnterKey && pc.get('piecescount').valid ? piecesActualWeight.focus() : pc.get('piecescount').markAsTouched()" 
                                  (keyup)="volumetricDetails(pc)"
                                  [ngClass]="{'is-invalid': pc.get('piecescount')?.touched && pc.get('piecescount')?.errors}" />
                                <div *ngIf="(pc.get('piecescount')?.touched) && pc.get('piecescount')?.errors" class="invalid-feedback">
                                  <span *ngIf="pc.get('piecescount').errors.required">required</span>
                                  <span *ngIf="pc.get('piecescount').value == 0">should be atleast 1</span>
                                </div>
                              </td>
                              <td class="actualweight">
                                <input #piecesActualWeight type="number" formControlName="piecesactualweight"
                                  class="form-control form-control-sm"
                                  (change)="calculateWeightNew(i);"
                                  (keydown)="piecesValidate($event)" 
                                  (keydown.enter)="useEnterKey && pc.get('piecesactualweight').valid ? piecesLength.focus() : pc.get('piecesactualweight').markAsTouched()" 
                                  [ngClass]="{'is-invalid': pc.get('piecesactualweight')?.touched && pc.get('piecesactualweight')?.errors}" />
                                <div *ngIf="(pc.get('piecesactualweight')?.touched) && pc.get('piecesactualweight')?.errors"
                                  class="invalid-feedback">
                                  <span *ngIf="pc.get('piecesactualweight').errors.required">required</span>
                                </div>
                              </td>
                              <td class="dimension-width">
                                <div class="input-group mb-2">
                                  <span class="input-group-text group-label-sm">L
                                  </span>
                                  <input #piecesLength type="number" formControlName="pieceslength"  class="form-control form-control-sm" 
                                    (keydown.enter)="useEnterKey && pc.get('pieceslength').valid ? piecesBreadth.focus() : pc.get('pieceslength').markAsTouched()"
                                    (keyup)="volumetricDetails(pc)"
                                    (keydown)="piecesValidate($event)"
                                    [ngClass]="{'is-invalid': pc.get('pieceslength')?.touched && pc.get('pieceslength')?.errors}" />

                                  <span class="input-group-text group-label-sm">B</span>
                                  <input #piecesBreadth type="number" formControlName="piecesbreadth" #piecesbreadth class="form-control form-control-sm" 
                                    (keydown.enter)="useEnterKey && pc.get('piecesbreadth').valid ? piecesHeight.focus() : pc.get('piecesbreadth').markAsTouched()"
                                    (keyup)="volumetricDetails(pc)"
                                    (keydown)="piecesValidate($event)"
                                    [ngClass]="{'is-invalid': pc.get('piecesbreadth')?.touched && pc.get('piecesbreadth')?.errors}" />

                                  <span class="input-group-text group-label-sm">H</span>
                                  <input #piecesHeight type="number" formControlName="piecesheight" #piecesheight class="form-control form-control-sm" 
                                    (keyup)="volumetricDetails(pc)"
                                    (keydown.enter)="useEnterKey && pc.get('piecesvolumetricweight').disabled? 
                                      (i === containers.controls.length - 1 ? focusSubmitBtn() : focusNextContainer(i + 1)): piecesVolumetricWeight.focus()"
                                      (keydown)="piecesValidate($event)" 
                                    [ngClass]="{'is-invalid': pc.get('piecesheight')?.touched && pc.get('piecesheight')?.errors}" />
                                </div>
                              </td>
                              <td class="volweight">
                                <input #piecesVolumetricWeight type="number" formControlName="piecesvolumetricweight" class="form-control form-control-sm" 
                                  (keyup)="calculateWeightNew()"
                                  (keydown)="piecesValidate($event)"
                                  (keydown.enter)="useEnterKey && (i === containers.controls.length - 1 ? focusSubmitBtn() : focusNextContainer(i + 1))" />
                              </td>
                              <td class="volweight">
                                <input type="number" formControlName="pieceschargeableweight" class="form-control form-control-sm"/>
                              </td>
                              <td class="deletepiece">
                                <i class="bx bx-trash font-size-16 align-middle ms-3" title="Delete"
                                  (click)="removeContainerCustom(i)"></i>
                              </td>

                            </tr>
                            <ng-container *ngIf="isRowExpanded(i)">
                              <tr>
                                <td colspan="12">
                                  <div class="card items-card">
                                    <div class="card-header bg-transparent border-bottom text-uppercase">Item Details</div>
                                    <div class="card-body" formGroupName="containeritemsgroup">
                                      <div class="row">
                                        <div class="col-md-3">
                                          <label for="description" class="form-label">Description<span class="mandatory">*</span></label>
                                          <input #descriptionRef type="text" class="form-control form-control-sm" id="description"
                                            formControlName="description"
                                            placeholder="Search or Enter Description" [resultTemplate]="rt"
                                            [inputFormatter]="formatterItemDescription"
                                            [ngbTypeahead]="searchItemDescription"
                                            (selectItem)="selectedItemDescriptionEvent(pc, $event)"
                                            [popupClass]="'desc-popup'" 
                                            (keydown.enter)="useEnterKey && pc.get('containeritemsgroup.description').valid ? focusItemWeightRef() : pc.get('containeritemsgroup.description').markAsTouched()"
                                            [ngClass]="{'is-invalid': pc.get('containeritemsgroup').get('description')?.touched && pc.get('containeritemsgroup').get('description')?.errors}">
                                          <div *ngIf="pc.get('containeritemsgroup').get('description')?.touched && pc.get('containeritemsgroup').get('description')?.errors"
                                            class="invalid-feedback">
                                            <span *ngIf="pc.get('containeritemsgroup').get('description').errors.required">Required</span>
                                          </div>
                                          <div *ngIf="pc.get('containeritemsgroup').get('description')?.touched && pc.get('containeritemsgroup').get('description')?.errors"
                                            class="invalid-feedback">
                                            <span *ngIf="pc.get('containeritemsgroup').get('description').errors.maxlength">Maximum 40 characters</span>
                                          </div>
                                          <ng-template #rt let-r="result" let-t="term">
                                            <ngb-highlight [result]="r.name" [term]="t"></ngb-highlight>
                                            <span> | {{r['hsncode']}}</span>
                                          </ng-template>
                                        </div>
                                        <div class="col-md-2">
                                          <label for="hsncode" class="form-label">HSN Code</label>
                                          <input #hsnCode type="text" class="form-control form-control-sm" id="hsncode" formControlName="hsncode" 
                                            (keydown.enter)="useEnterKey && pc.get('containeritemsgroup.hsncode').valid ? focusItemWeightRef() : pc.get('containeritemsgroup.hsncode').markAsTouched()">
                                        </div>
                                        <div class="col-md-1">
                                          <label for="weight" class="form-label">Weight</label>
                                          <input #weightRef type="number" class="form-control form-control-sm" id="weight" formControlName="weight" 
                                            (keydown.enter)="useEnterKey && pc.get('containeritemsgroup.weight').valid ? quantity.focus() : pc.get('containeritemsgroup.weight').markAsTouched()" appLimitDigits [length] = "13"
                                            [ngClass]="{'is-invalid': pc.get('containeritemsgroup').get('weight')?.touched && pc.get('containeritemsgroup').get('weight')?.errors}">
                                          <div *ngIf="pc.get('containeritemsgroup').get('weight')?.touched && pc.get('containeritemsgroup').get('weight')?.errors" class="invalid-feedback">
                                            <span *ngIf="pc.get('containeritemsgroup').get('weight').errors.pattern">Maximum 9 digits and atleast 3 decimals</span>
                                          </div>
                                        </div>
                                        <div class="col-md-2">
                                          <label for="unit" class="form-label">Unit</label>
                                          <ng-select #unit formControlName="unit" [items]="containerItemUnitOptions"
                                            bindLabel="name" [bindValue]="'code'" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false" 
                                            (click)="quantity.focus()" (keydown.enter)="quantity.focus()"></ng-select>
                                        </div>
                                        <div class="col-md-1">
                                          <label for="quantity" class="form-label">Quantity<span class="mandatory">*</span></label>
                                          <input #quantity type="number" class="form-control form-control-sm" id="quantity" appLimitDigits [length] = "3"
                                            formControlName="quantity" (keyup)="calculateItemAmount(pc)"
                                            (keydown)="onKeyDownblockKeyForShipment($event)" 
                                            (keydown.enter)="useEnterKey && pc.get('containeritemsgroup.quantity').valid ? rate.focus() : pc.get('containeritemsgroup.quantity').markAsTouched()"
                                            [ngClass]="{'is-invalid': pc.get('containeritemsgroup').get('quantity')?.touched && pc.get('containeritemsgroup').get('quantity')?.errors}">
                                          <div *ngIf="pc.get('containeritemsgroup').get('quantity')?.touched && pc.get('containeritemsgroup').get('quantity')?.errors" class="invalid-feedback">
                                            <span *ngIf="pc.get('containeritemsgroup').get('quantity').errors.required">Required</span>
                                          </div>

                                          <div *ngIf="pc.get('containeritemsgroup').get('quantity')?.touched && pc.get('containeritemsgroup').get('quantity')?.errors" class="invalid-feedback">
                                            <span *ngIf="pc.get('containeritemsgroup').get('quantity').errors.pattern">Maximum 3 digits only</span>
                                            <span *ngIf="pc.get('containeritemsgroup').get('quantity').errors.nonZero">Quantity cannot be zero</span>
                                          </div>

                                        </div>
                                        <div class="col-md-1">
                                          <label for="rate" class="form-label">Rate<span class="mandatory">*</span></label>
                                          <input #rate type="number" class="form-control form-control-sm" id="rate" appLimitDigits [length] = "14"
                                            formControlName="rate" (keyup)="calculateItemAmount(pc)" 
                                            (keydown.enter)="useEnterKey && pc.get('containeritemsgroup.rate').valid ? pieceAddBtn.nativeElement.focus() : pc.get('containeritemsgroup.rate').markAsTouched()"
                                            [ngClass]="{'is-invalid': pc.get('containeritemsgroup').get('rate')?.touched && pc.get('containeritemsgroup').get('rate')?.errors}">
                                          <div *ngIf="pc.get('containeritemsgroup').get('rate')?.touched && pc.get('containeritemsgroup').get('rate')?.errors" class="invalid-feedback">
                                            <span *ngIf="pc.get('containeritemsgroup').get('rate').errors.required">Required</span>
                                          </div>
                                          <div *ngIf="pc.get('containeritemsgroup').get('rate')?.touched && pc.get('containeritemsgroup').get('rate')?.errors" class="invalid-feedback">
                                            <span *ngIf="pc.get('containeritemsgroup').get('rate').errors.pattern">Maximum 10 digits and atleast 3 decimals</span>
                                          </div>
                                        </div>
                                        <div class="col-md-1">
                                          <label for="amount" class="form-label">Amount</label>
                                          <input #amount type="number" class="form-control form-control-sm" formControlName="amount" 
                                            (keydown.enter)="useEnterKey && pc.get('containeritemsgroup').get('amount').valid ? pieceAddBtn.nativeElement.focus() : pc.get('containeritemsgroup').get('amount').markAsTouched()">
                                        </div>
                                        <div class="col-1 mt-3">
                                          <label class="form-label"></label>
                                          <ng-container *ngIf="!pc.get('containeritemsgroup').get('editmode').value">
                                            <button #pieceAddBtn type="button" class="btn btn-info btn-label btn-sm w-xs btn-only-icon d-inline-block mt-1"
                                              (click)="addSubItem(i, pc.get('containeritemsgroup'))"
                                              (keydown.enter)="addSubItem(i, pc.get('containeritemsgroup'))">
                                                <i class="bx bx-plus label-icon "></i>Add
                                            </button>
                                          </ng-container>
                                          <ng-container *ngIf="pc.get('containeritemsgroup').get('editmode').value">
                                            <button type="button" class="btn btn-success btn-label btn-sm w-xs btn-only-icon d-inline-block mt-1"
                                              (click)="updateSubItem(pc.get('containeritemsgroup'))"
                                              (keydown.enter)="updateSubItem(pc.get('containeritemsgroup'))">
                                                <i class="bx bx-save label-icon "></i>Save</button>

                                            <button type="button" class="btn btn-danger btn-label btn-sm w-xs btn-only-icon d-inline-block mt-1"
                                              (click)="cancelUpdateSubItem(pc.get('containeritemsgroup'))">
                                                <i class="bx bx-exit label-icon "></i>Cancel</button>
                                          </ng-container>

                                          <!-- <button type="button" class="btn btn-primary btn-sm d-flex" (click)="addSubItem(i, null)">
                                                  <i class="bx bx-plus font-size-16 me-1"></i>
                                                  Add Item
                                              </button> -->
                                          <!-- <button type="button" class="btn btn-warning btn-label btn-sm w-xs btn-only-icon">
                                                <i class="bx bx-edit label-icon "></i> Edit</button>
                                              <button type="button" class="btn btn-info btn-label btn-sm w-xs btn-only-icon">
                                                <i class="bx bx-save label-icon "></i> Save</button> -->
                                        </div>
                                        <div class="col-9">
                                          <div class="d-flex justify-content-end">
                                            <!-- <button type="button" class="btn btn-warning btn-label btn-sm w-xs btn-only-icon">
                                                  <i class="bx bx-edit label-icon "></i> Edit</button>
                                                <button type="button" class="btn btn-info btn-label btn-sm w-xs btn-only-icon">
                                                  <i class="bx bx-save label-icon "></i> Save</button> -->
                                          </div>
                                        </div>
                                      </div>
                                      <div class="row mt-3">
                                        <div class="col-12">
                                          <div class="table-responsive items-table">
                                            <table class="table table-sm m-0">
                                              <thead class="table-light display-table-row">
                                                <tr>
                                                  <th style="width: 400px;">Description</th>
                                                  <th style="width: 150px;">HSN Code</th>
                                                  <th>Weight</th>
                                                  <th>Unit</th>
                                                  <th>Quantity</th>
                                                  <th>Rate</th>
                                                  <th>Amount</th>
                                                  <th></th>
                                                </tr>
                                              </thead>
                                              <tbody style="max-height: 310px; overflow-y: auto;">
                                                <ng-container formArrayName="subitems"
                                                  *ngFor="let item of subItem(i).controls; let ci=index">
                                                  <tr [formGroupName]="ci" class="tabl-row-wid">
                                                    <td style="width: 400px;">
                                                      {{item.value.itemdescription}}
                                                    </td>
                                                    <td style="width: 150px;">
                                                      {{item.value.itemhsncode}}
                                                    </td>
                                                    <td>
                                                      {{item.value.itemweight}}
                                                    </td>
                                                    <td>
                                                      {{item.value.itemunit}}
                                                    </td>
                                                    <td>
                                                      {{item.value.itemquantity}}
                                                    </td>
                                                    <td>
                                                      {{item.value.itemrate}}
                                                    </td>
                                                    <td>
                                                      {{item.value.itemamount}}
                                                    </td>
                                                    <td class="d-flex">
                                                      <i class="bx bx-edit font-size-16 align-middle me-2"
                                                        (click)="editSubItem(pc.get('containeritemsgroup'), item, ci)"></i>
                                                      <i class="bx bx-trash font-size-16 align-middle me-2"
                                                        (click)="removeSubItem(i, ci)"></i>
                                                    </td>
                                                  </tr>
                                                </ng-container>
                                                <ng-container *ngIf="subItem(i).controls.length === 0">
                                                  <tr>
                                                    <td colspan="12" class="no-data-available">No data
                                                      available</td>
                                                  </tr>
                                                </ng-container>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </ng-container>
                          </ng-container>
                        </ng-container>
                      </tbody>
                  </table>
              </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="button-items mb-2">
            <button type="button" class="btn btn-primary btn-sm w-sm" (click)="addAwb()">Add</button>
            <button type="button" class="btn btn-secondary btn-sm w-sm" (click)="resetManifestForm()">Reset</button>
          </div>
        </div>
      </form>
      <form [formGroup]="generateForm">
        <div class="card">
          <div class="card-header bg-transparent border-bottom text-uppercase">{{viewOnlyPage? 'Manifest Items': 'Manage Items'}}</div>
          <div class="card-body">
            <div class="row" *ngIf="!viewOnlyPage">
              <div class="col-md-2">
                <div class="mb-2 d-flex flex-column">
                  <div class="label">
                    <!-- <label for="status" class="form-label">Manifest Type</label> -->
                  </div>
                  <div role="group" aria-label="radio button group" class="btn-group">
                    <input #btnradio6 type="radio" id="btnradio6" autocomplete="off" class="btn-check" formControlName="chkAwbWise"
                      value="awbwise" (change)="onChkAwbWiseChange(true)" 
                      (keydown.enter)="useEnterKey && btnradio7">
                    <label for="btnradio6" class="btn btn-outline-secondary btn-sm">AWB wise</label>
                    <input #btnradio7 type="radio" id="btnradio7" autocomplete="off" class="btn-check" formControlName="chkAwbWise"
                      value="bagwise" (change)="onChkAwbWiseChange(false)" 
                      (keydown.enter)="useEnterKey && awbNoInput.nativeElement.focus()">
                    <label for="btnradio7" class="btn btn-outline-secondary btn-sm">Bag wise</label>
                  </div>
                </div>
              </div>
            </div>
            <ng-container *ngIf="showAwbWise">
              <div class="row" *ngIf="!viewOnlyPage">
                <div class="col-md-2">
                  <div class="mb-2">
                    <label for="awbNo" class="form-label">AWB or Forwarding No</label>
                    <div class="input-group">
                      <input #awbNoInput formControlName="txtAwbOrForwardingNo" type="text" class="form-control col form-control-sm"
                        placeholder="Type to search" [ngbTypeahead]="searchAWBNumber" [resultTemplate]="rt"
                        [inputFormatter]="awbDetailsFormatter" maxlength="30" (selectItem)="onSelectForwardingORAwbNo('awb')"
                        [ngClass]="{'is-invalid': isGenerateFormSubmitted && generateForm.get('txtAwbOrForwardingNo').errors}"
                        (keydown.enter)="useEnterKey && generateForm.get('txtAwbOrForwardingNo').valid 
                                        ? (manifestForm.get('manifestFor').value === 'Third Party'? addAWBActionBtn.focus(): crnmhbsno.nativeElement.focus()) : generateForm.get('txtAwbOrForwardingNo').markAsTouched()"/>
                         <ng-template #rt let-r="result" let-t="term">
                           <ngb-highlight [result]="r.awbnumber" [term]="t"></ngb-highlight>
                          </ng-template>
                      <div *ngIf="isGenerateFormSubmitted && generateForm.get('txtAwbOrForwardingNo').errors" class="invalid-feedback">
                        <span *ngIf="generateForm.get('txtAwbOrForwardingNo').errors.required">AWB or Forwarding No. is required</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-2" *ngIf="manifestFor === 'Service Center'">
                  <div class="mb-2">
                    <label for="crnmhbsno" class="form-label">CRN MHBS No.</label>
                    <input #crnmhbsno id="crnmhbsno" type="text" class="form-control form-control-sm" formControlName="txtCRNNo" maxlength="30" 
                      (keydown.enter)="useEnterKey && addAWBActionBtn.focus()">
                  </div>
                </div>
                <div class="col-md-2 mt-3">
                  <div class="mb-2 mt-1">
                    <button #addAWBActionBtn type="button" class="btn btn-primary btn-sm"
                      (click)="addItems('AWB')">
                      <i class="mdi mdi-plus"></i>Add
                    </button>
                  </div>
                </div>
                
              </div>
              <div class="row">
                <div class="col-md-12 grid-container mt-2">
                  <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid" class="ag-theme-balham"
                    [rowData]="selectedAWBList" [columnDefs]="columnDefsAwbWise" [animateRows]="true" [context]="context"
                    [defaultColDef]="defaultColDef" [enableCellTextSelection]="true" [suppressMenuHide]="true"
                    [pagination]="true" (gridReady)="onGridReady($event)" [gridOptions]="GridOptionsAWBWise">
                  </ag-grid-angular>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="!showAwbWise">
              <div class="row" *ngIf="!viewOnlyPage">
                <div class="col-md-1">
                  <div class="mb-2">
                    <label for="bagNo" class="form-label">Bag No.</label>
                    <ng-select #bagNoRef id="bagNo" [items]="bagsList" bindLabel="bagno" placeholder="Select" [bindValue]="'id'"
                      [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlBagNo" 
                      (keydown.enter)="useEnterKey && generateForm.get('ddlBagNo').dirty ? bagAddBtn.focus() : generateForm.get('ddlBagNo').markAsTouched()">
                    </ng-select>
                  </div>
                </div>
                <div class="col-md-2 mt-3">
                  <div class="mb-2 mt-1">
                    <button #bagAddBtn type="button" class="btn btn-primary btn-sm" 
                      (click)="addItems('BAG')"><i class="mdi mdi-plus"></i>Add
                    </button>
                  </div>
                </div>
                
              </div>
              <div class="row">
                <div title="All Bags" class="col-md-5 grid-container">
                  <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid" class="ag-theme-balham"
                    [rowData]="selectedBagsList" [columnDefs]="columnDefsBagWise" [animateRows]="true" [context]="context"
                    [defaultColDef]="defaultColDef" [enableCellTextSelection]="true" [suppressMenuHide]="true"
                    [pagination]="true" (gridReady)="onGridReady($event)" [gridOptions]="gridOptionsBagWise">
                  </ag-grid-angular>
                </div>
                <div title="Selected Bag Details" class="col-md-3 grid-container">
                  <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid" class="ag-theme-balham"
                    [rowData]="rowDataLatestBagDetail" [columnDefs]="colDefsLatestBagDetail" [animateRows]="true"
                    [context]="context" [defaultColDef]="defaultColDef" [enableCellTextSelection]="true"
                    [suppressMenuHide]="true" [pagination]="true" (gridReady)="onGridReady($event)"
                    [gridOptions]="gridOptionsBagDetail">
                  </ag-grid-angular>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </form>
    </div>
    <ngb-accordion #a="ngbAccordion" class="accordion range-accordion" (click)="flight1Ref.nativeElement.focus()">
      <ngb-panel id="1">
        <ng-template ngbPanelTitle class="text-black">
          <i class="bx bx-flight text-primary me-1"></i>Flight Details
        </ng-template>
        <ng-template ngbPanelContent>
          <form class="col-12" [formGroup]="flightForm">
            <div class="row">
              <div class="col-md-2">
                <div class="mb-2">
                  <label for="flight1" class="form-label">Flight 1 No.</label>
                  <div class="input-group">
                    <input #flight1Ref formControlName="txtFlight1" type="text" class="form-control col form-control-sm"
                      placeholder="Type to search" [ngbTypeahead]="searchFlight" [resultTemplate]="rt"
                      [inputFormatter]="flightFormatter" maxlength="10"  
                      (keydown.enter)="useEnterKey && arrivalDate1.focus()"/>
                  </div>
                  <ng-template #rt let-r="result" let-t="term">
                    <ngb-highlight [result]="r.name" [term]="t"></ngb-highlight>
                    <!-- <span> | {{r['id']}}</span> -->
                  </ng-template>
                </div>
              </div>
              <div class="col-md-2">
                <div class="mb-2">
                  <label for="arrivalDate1" class="form-label">Arrival Date</label>
                  <input #arrivalDate1 type="datetime-local" id="arrivalDate1" class="form-control form-control-sm"
                    formControlName="txtFlight1ArrivalDate" 
                    (keydown.enter)="useEnterKey && flight2.focus()">
                </div>
              </div>
              <div class="col-md-2">
                <div class="mb-2">
                  <label for="flight2" class="form-label">Flight 2 No.</label>
                  <div class="input-group">
                    <input #flight2 formControlName="txtFlight2" type="text" class="form-control col form-control-sm"
                      placeholder="Type to search" [ngbTypeahead]="searchFlight" [resultTemplate]="rt"
                      [inputFormatter]="flightFormatter" maxlength="10"  
                      (keydown.enter)="useEnterKey && arrivalDate2.focus()"/>
                  </div>
                  <ng-template #rt let-r="result" let-t="term">
                    <ngb-highlight [result]="r.name" [term]="t"></ngb-highlight>
                    <!-- <span> | {{r['code']}}</span> -->
                  </ng-template>
                </div>
              </div>
              <div class="col-md-2">
                <div class="mb-2">
                  <label for="arrivalDate2" class="form-label">Arrival Date</label>
                  <input #arrivalDate2 type="datetime-local" id="arrivalDate2" class="form-control form-control-sm"
                    formControlName="txtFlight2ArrivalDate" 
                    (keydown.enter)="useEnterKey && cdNo.focus()">
                </div>
              </div>
              <div class="col-md-2">
                <div class="mb-2">
                  <label for="cdNo" class="form-label">CD No.</label>
                  <input #cdNo type="text" id="cdNo" class="form-control form-control-sm" formControlName="txtCDNo"
                  (keydown.enter)="useEnterKey && airlinePrefix.focus()">
                </div>
              </div>
              <div class="col-md-2">
                <div class="mb-2">
                  <label for="ediMasterNo" class="form-label">Master EDI No.</label>
                  <input #ediMasterNo type="text" id="ediMasterNo" class="form-control form-control-sm" formControlName="txtEDIMasterNo"
                  (keydown.enter)="useEnterKey && airlinePrefix.focus()">
                </div>
              </div>
              <div class="row flex-wrap">
                <div class="col-md-6">
                    <label for="masterAwbNo" class="form-label">Master AWB No. :<span>{{masterAwbNo}}</span></label>
                    <div class="input-group mb-2">
                        <span class="input-group-text group-label-sm full-width-custom">Airline Prefix</span>
                        <input #airlinePrefix type="number" class="form-control form-control-sm full-width-custom" formControlName="txtAirlinePrefix" maxlength="4" 
                            (input)="onEnterFlightSeries()"
                            (keydown.enter)="useEnterKey && awbNoSeries1.focus()">
                        <span class="input-group-text group-label-sm full-width-custom">AWB No. Series</span>
                        <input #awbNoSeries1 type="number" class="form-control form-control-sm full-width-custom" formControlName="txtAwbSeries1" maxlength="4"
                            (input)="onEnterFlightSeries()" 
                            (keydown.enter)="useEnterKey && awbNoSeries2.focus()">
                        <span class="input-group-text group-label-sm full-width-custom">AWB No. Series</span>
                        <input #awbNoSeries2 type="number" class="form-control form-control-sm full-width-custom" formControlName="txtAwbSeries2" maxlength="4"
                            (input)="onEnterFlightSeries()" 
                            (keydown.enter)="useEnterKey && submitBtn.nativeElement.focus()">
                    </div>
                </div>
            </div>
            </div>
          </form>
        </ng-template>
      </ngb-panel>
    </ngb-accordion>
    <div class="row mb-3 mt-3">
      <div class="col-12">
        <div class="button-items">
          <button #submitBtn *ngIf="!viewOnlyPage" type="button" class="btn btn-primary w-sm" (click)="addManifest()" (keydown.enter)="addManifest()">
            {{manifestId?'Update':'Create'}}</button>
          <a routerLink="/operation/manifests">
            <button type="button" class="btn btn-secondary w-sm">Cancel</button></a>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!permConfig.isAddAllowed">
  <app-forbidden></app-forbidden>
</ng-container>